export const getUrlParam = (param: string, defaultValue = '') => {
  return new URLSearchParams(window?.location?.search)?.get(param) || defaultValue;
};
